import { render, staticRenderFns } from "./app-pagination.vue?vue&type=template&id=59491371&scoped=true&"
import script from "./app-pagination.vue?vue&type=script&lang=js&"
export * from "./app-pagination.vue?vue&type=script&lang=js&"
import style0 from "./app-pagination.vue?vue&type=style&index=0&id=59491371&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59491371",
  null
  
)

export default component.exports